import {memo} from 'react';
import Link from 'next/link';
import Image from "next/image";

const PromoItem = props => {
	const {styles, item} = props;
	return (
        <div className={`customCol`}>
            <div className={`${styles.listingCard} ${styles.listingCardPromo}`}>
				{item.href ? (
					(<Link href={item.href} target='_blank'>

                        <div className={styles.promoListImg}>
                            <Image
                                src={item.imageUrl}
                                fill
                                sizes="100vw"
                                style={{
                                    objectFit: "contain"
                                }} />{' '}
                        </div>

                    </Link>)
				) : (
					<div className={styles.promoListImg}>
						<Image
                            src={item.imageUrl}
                            fill
                            sizes="100vw"
                            style={{
                                objectFit: "contain"
                            }} />{' '}
					</div>
				)}
			</div>
        </div>
    );
};

export default memo(PromoItem);
